export * from "./department-added";
export * from "./department-already-exists";
export * from "./department-not-found";
export * from "./department-updated";

import { DepartmentAddedMessageTemplateComponent } from "./department-added";
import { DepartmentAlreadyExistsMessageTemplateComponent } from "./department-already-exists";
import { DepartmentNotFoundMessageTemplateComponent } from "./department-not-found";
import { DepartmentUpdatedMessageTemplateComponent } from "./department-updated";

export const DepartmentMessages = [
  DepartmentAddedMessageTemplateComponent,
  DepartmentAlreadyExistsMessageTemplateComponent,
  DepartmentNotFoundMessageTemplateComponent,
  DepartmentUpdatedMessageTemplateComponent,
];
